<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">收费月份添加</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="addForm" :rules="rules" ref="addForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="收费项目开始时间">
                                    <el-date-picker
                                        v-model="addForm.startTime"
                                        type="datetime"
                                        style="width:100%"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        placeholder="选择开始时间">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="收费项目结束时间">
                                    <el-date-picker
                                        v-model="addForm.endTime"
                                        type="datetime"
                                        style="width:100%"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        placeholder="选择结束时间">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="收费项目"  required prop="deductionItemCode">
                                    <el-select v-model="addForm.deductionItemCode" filterable placeholder="请选择收费项目" style="width:100%">
                                        <el-option
                                        v-for="item in deductionItemValue"
                                        :key="item.deductionItemCode"
                                        :label="item.name"
                                        :value="item.deductionItemCode">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="扣费金额" required prop="money">
                                    <el-input type="number" v-model="addForm.money" placeholder="请输入金额"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="备注" required prop="remarks">
                                    <el-input v-model="addForm.remarks" placeholder="请输入备注"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
            </div>

            
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Add',
        data() {
            return {

                loading: false,
                deductionItemValue:[],
                elderlyName:'',
                createTime:'',
                deductionItemName:'',
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    elderlyCode:'',
                    checkinCode:'',
                    deductionItemCode:'',
                    startTime:'',
                    endTime:'',
                    remarks:'',
                    money:''
                },
                rules:{
                    deductionItemCode:[
                        { required: true, message: '请选择扣费项目', trigger: 'change' },
                    ],
                    remarks:[
                        { required: true, message: '请输入备注', trigger: 'blur' },
                    ],
                    money:[
                        { required: true, message: '请输入金额', trigger: 'blur' },
                        {
                            pattern: /^([0-9]?)+(\.[0-9][0-9]?)?$/,
                            message: "金额输入有误", trigger: 'blur'
                        }
                    ],
                }


            }
        },

        methods: {
            init(row){
                this.$refs.addForm.resetFields();
                this.elderlyName = row.name;
                this.addForm.elderlyCode = row.elderlyCode;
                this.addForm.checkinCode = row.checkinCode;
                this.getDeductionItem();
            },
            closeSelf() {
                this.$emit("closeFee");
            },
            getDeductionItem(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"DeductionItem/List",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        status:1
                    }
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.deductionItemValue = response.data.data;
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            
            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },
            

            addSubmit(){
                
                this.loading = true;
                
                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"DeductionHandRecord/Add",
                    data: this.addForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                             this.$emit("closeFee");
                             this.$emit("openVoucher",response.data.data);
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 800px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
